<template>
  <div class="order-container">
    <div class="page" v-if="$route.name === 'orderManagement'">
      <wgTabs :tabData="tabs" @tabChange="getActive" />
      <br />
      <div class="filter">
        <el-form :model="formQuery" inline size="small">
          <div class="form-left">
            <el-form-item label="学生姓名">
              <el-input v-model="formQuery.stuName" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品名称">
              <el-input v-model="formQuery.productName" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品类型">
              <el-select
                v-model="formQuery.productCategory"
                placeholder="请选择"
                filterable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item of productCategoryList"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="商品状态">
              <el-select
                v-model="formQuery.productState"
                placeholder="请选择"
                filterable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item of productStateList"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="订单编号">
              <el-input v-model="formQuery.orderNumber" clearable></el-input>
            </el-form-item>
            <br />
            <el-form-item label="兑换时间">
              <el-date-picker
                v-model="formQuery.time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                placement="bottom-start"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="methodSearch"
                v-if="$attrs.methodAuthTabView('查询')"
                >查询</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="content">
        <el-table
          size="small"
          :data="tableData"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#909399',
            'font-size': '14px',
          }"
          :header-row-style="{
            'border-radius': '5px',
            overflow: 'hidden',
          }"
          stripe
        >
          <el-table-column
            v-for="item in tableTitle"
            :key="item.value"
            :label="item.label"
            :prop="item.value"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="item.value === 'productCategory'">
                {{ productCategoryMap[scope.row[item.value]] }}
              </div>
              <div v-else-if="item.value === 'productState'">
                {{ productStateMap[scope.row[item.value]] }}
              </div>
              <div
                v-else-if="item.value === 'orderState'"
                style="display:flex;justify-content:center;align-items:center"
              >
                <i
                  :style="{
                    display: 'inline-flex',
                    width: '5px',
                    height: '5px',
                    borderRadius: '50%',
                    marginRight: '5px',
                    backgroundColor:
                      scope.row.orderState === 0
                        ? '#2488ef'
                        : scope.row.orderState === 1
                        ? '#e4393c'
                        : '#17A81C',
                  }"
                ></i>
                <span>
                  {{ tabsMap[scope.row[item.value]] }}
                </span>
              </div>
              <div v-else-if="item.value === 'operation'">
                <el-button
                  type="text"
                  size="mini"
                  @click="methodToDetail(scope.row)"
                  v-if="scope.row.orderState === 0"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="methodToDetail(scope.row)"
                  v-else
                >
                  查看记录
                </el-button>
              </div>
              <div v-else>{{ scope.row[item.value] }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.currentPage"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import { api_schoolOrderQueryList } from '@/api/javaApi'

import wgTabs from '../../../components/wgTabs.vue'

export default {
  name: 'orderManagement',
  components: {
    wgTabs,
  },
  props: ['campusData'],
  data: () => ({
    tabs: {
      active: null,
      list: [
        { label: '全部', index: null },
        { label: '已完成', index: 2 },
        { label: '待兑换', index: 0 },
        { label: '驳回', index: 1 },
      ],
    },
    tabsMap: {
      null: '全部',
      0: '待兑换',
      1: '驳回',
      2: '已完成',
    },
    productCategoryList: [
      { label: '全部', index: null },
      { label: '伴学精灵', value: 0 },
      { label: '头像挂件', value: 1 },
      { label: '实物', value: 2 },
      { label: '头像', value: 3 },
    ],
    productCategoryMap: {
      null: '全部',
      0: '伴学精灵',
      1: '头像挂件',
      2: '实物',
      3: '头像',
    },
    productStateList: [
      { label: '全部', index: null },
      { label: '兑换中', value: 0 },
      // { label: '下架', value: 1 },
      { label: '库存不足', value: 2 },
      // { label: '删除', value: 3 },
    ],
    productStateMap: {
      null: '全部',
      0: '兑换中',
      1: '下架',
      2: '库存不足',
      3: '删除',
    },
    formQuery: {
      eduCampusId: null,
      stuName: '',
      productName: '',
      productCategory: null,
      productState: null,
      time: null,
      orderNumber: '',
    },
    tableTitle: [
      { label: '兑换编号', value: 'orderNumber' },
      { label: '商品类型', value: 'productCategory' }, // 商品类型（0为伴学精灵，1为头衔，2为实物）
      { label: '商品名称', value: 'productName' },
      // { label: '商品状态', value: 'productState' }, // 商品状态（0兑换中，1下架，2库存不足，3删除）
      { label: '学生姓名', value: 'stuName' },
      { label: '兑换数量', value: 'exchangeNum' },
      { label: '消耗星币', value: 'consumeStarNum' },
      { label: '兑换时间', value: 'exchangeTime' },
      { label: '兑换状态', value: 'orderState' },
      { label: '操作人', value: 'auditor' },
      { label: '操作', value: 'operation' },
    ],
    tableData: [],
    page: {
      pageSize: 10,
      currentPage: 1,
      total: 1,
    },
  }),
  watch: {
    $route(to) {
      if (to.query.refresh) {
        this.methodSearch()
        const currentRoute = to
        this.$router.replace({ ...currentRoute, query: {} })
      }
    },
  },
  created() {
    this.formQuery.eduCampusId = this.campusData[0]
    this.methodSearch()
  },
  methods: {
    // 获取tab切换index
    getActive(active) {
      this.tabs.active = active
      this.resetQuery()
      this.methodSearch()
    },
    // 查看详情
    methodToDetail(row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          eduCampusId: this.formQuery.eduCampusId,
          stuId: row.stuId,
        },
      })
    },
    // 切换页数
    handleSizeChange(size) {
      this.page.pageSize = size
      this.page.currentPage = 1
      this.methodSearch()
    },
    // 切换页码
    handleCurrentChange(page) {
      this.page.currentPage = page
      this.methodSearch()
    },
    // 查询
    methodSearch() {
      this.schoolOrderQueryList()
    },
    // 重置查询参数
    resetQuery() {
      this.formQuery = {
        ...this.formQuery,
        ...{
          stuName: '',
          productName: '',
          productCategory: null,
          productState: null,
          time: null,
          orderNumber: '',
        },
      }
      this.tableData = []
    },
    // 查看订单列表
    schoolOrderQueryList() {
      let startTime = null,
        endTime = null
      if (this.formQuery.time) {
        startTime =
          this.formQuery.time.length > 0 ? this.formQuery.time[0] : null
        endTime = this.formQuery.time.length > 0 ? this.formQuery.time[1] : null
      }
      api_schoolOrderQueryList({
        eduCampusId: this.formQuery.eduCampusId, // 校区Id
        stuName: this.formQuery.stuName, //学生姓名
        productName: this.formQuery.productName, //商品名称
        productCategory: this.formQuery.productCategory, //商品类型
        // productState: this.formQuery.productState, //商品状态
        startTime, //开始时间
        endTime, //结束时间
        orderNumber: this.formQuery.orderNumber, //订单编号
        orderStateList: this.tabs.active === null ? null : [this.tabs.active], // 订单状态
        pageRequest: {
          // 页码信息
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
        },
      }).then((res) => {
        console.log(res)
        if (res.content) this.tableData = res.content
        this.page = {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.order-container {
  width: 100%;
  height: 100%;
  .page {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px 30px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px #f0f4f5;
    border-radius: 5px;
    border: 1px solid #f4f5f9;

    .filter {
      .el-form {
        display: flex;
        justify-content: space-between;
      }
    }
    .content {
      .pagination {
        display: flex;
        justify-content: flex-end;
        padding: 10px 0;
      }
    }
  }
}
</style>
